var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGender(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 23.437L13.0627 27.4998",
    stroke: "#8C18C3",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9.5H27V14",
    stroke: "#8C18C3",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9998 9.5L22.6738 13.826",
    stroke: "#8C18C3",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 27.5002L13.0905 23.4097",
    stroke: "#8C18C3",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.895 14.9414C17.8095 15.0067 17.721 15.0667 17.6445 15.1439C17.3197 15.4687 17.1022 15.8669 16.9822 16.2974C17.7997 16.4024 18.5587 16.7564 19.1512 17.3489C19.8593 18.0569 20.25 18.9989 20.25 20.0002C20.25 21.0014 19.8593 21.9434 19.1512 22.6522C18.4432 23.3609 17.5013 23.7502 16.5 23.7502C15.4987 23.7502 14.5568 23.3602 13.8488 22.6522C13.1408 21.9442 12.75 21.0014 12.75 20.0002C12.75 19.3514 12.9292 18.7357 13.2375 18.1844C13.1647 17.7974 13.125 17.4022 13.125 17.0002C13.125 16.6267 13.1625 16.2599 13.2248 15.8999C13.074 16.0214 12.927 16.1489 12.7882 16.2877C11.7967 17.2799 11.25 18.5977 11.25 20.0002C11.25 21.4027 11.7967 22.7204 12.7882 23.7127C13.7797 24.7049 15.0975 25.2502 16.5 25.2502C17.9025 25.2502 19.2202 24.7042 20.2118 23.7127C21.2032 22.7212 21.75 21.4027 21.75 20.0002C21.75 18.5977 21.2032 17.2799 20.2118 16.2877C19.5585 15.6344 18.762 15.1792 17.895 14.9414Z",
    fill: "#8C18C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2118 13.2875C22.2202 12.296 20.9025 11.75 19.5 11.75C18.0975 11.75 16.7797 12.296 15.7882 13.2875C14.7967 14.279 14.25 15.5975 14.25 17C14.25 18.4025 14.7967 19.7203 15.7882 20.7125C16.4415 21.3657 17.238 21.821 18.105 22.0588C18.1905 21.9935 18.279 21.9335 18.3555 21.8562C18.6803 21.5315 18.8978 21.1332 19.0178 20.7027C18.2003 20.5977 17.4413 20.2437 16.8488 19.6512C16.1408 18.9432 15.75 18.0012 15.75 17C15.75 15.9987 16.1408 15.0567 16.8488 14.348C17.5568 13.6392 18.4987 13.25 19.5 13.25C20.5013 13.25 21.4432 13.64 22.1512 14.348C22.8593 15.056 23.25 15.9987 23.25 17C23.25 17.6487 23.0708 18.2645 22.7625 18.8157C22.8345 19.2027 22.875 19.598 22.875 20C22.875 20.3735 22.8375 20.7402 22.7753 21.1002C22.926 20.9787 23.073 20.8512 23.2118 20.7125C24.2032 19.7203 24.75 18.4025 24.75 17C24.75 15.5975 24.2032 14.2797 23.2118 13.2875Z",
    fill: "#8C18C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.d38d5191e8c3e800dc4f102a312a9673.svg";
export { ForwardRef as ReactComponent };